import { patchSchema } from '@takeshape/schema';
import { createRoutine } from 'app/common/utils/new-routines';
import type { ProjectSchemaCompat } from 'app/compat/types';
import type { SagaIterator } from 'redux-saga';
import { call, select, takeLatest } from 'redux-saga/effects';
import { getRoutineSaga } from '../../common/utils/new-sagas.js';
import { setProjectEndpoint } from '../../graphql-client.js';
import { type SchemaUpdate, updateSchemaMutation } from '../api.js';
import { getBranchQueryArgs, getUserSchema } from '../selectors.js';
import type { BranchQueryArgs } from '../types.js';

export type UpdateSchemaResponse = {
  userSchema: ProjectSchemaCompat;
  runtimeSchema: ProjectSchemaCompat;
};

export type UpdateSchemaMeta = {
  operation: 'add' | 'update' | 'remove';
  shapeId?: string;
};

export const updateSchema = createRoutine('branches/UPDATE_SCHEMA')<
  UpdateSchemaMeta | undefined,
  SchemaUpdate,
  undefined,
  UpdateSchemaResponse,
  string,
  undefined
>();

export function* updateSchemaSaga(payload: SchemaUpdate): SagaIterator {
  const branch: BranchQueryArgs = yield select(getBranchQueryArgs, {});
  const runtimeSchema: ProjectSchemaCompat = yield call(updateSchemaMutation, {
    ...payload,
    ...branch
  });
  const userSchema: ProjectSchemaCompat = yield select(getUserSchema);
  const updatedUserSchema = patchSchema(userSchema, payload);

  setProjectEndpoint(branch.projectId, branch.branchName, runtimeSchema.schemaHash);
  return { runtimeSchema, userSchema: updatedUserSchema };
}

export default function* root(): SagaIterator {
  yield takeLatest(updateSchema.requested, getRoutineSaga(updateSchema, updateSchemaSaga));
}
